"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _FlexItem = _interopRequireDefault(require("./FlexItem"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styleKeys = ['display', 'flexDirection', 'flexWrap', 'justifyContent', 'alignItems', 'padding', 'itemSpacing', 'itemFlexBasis'];
/**
 * The FlexLayout component is commonly used to evenly space children items
 * 20px (default) apart in a row or column. To utilize its more advanced
 * properties, it is recommended to have an understanding of CSS Flexbox.
 * For more details, check out this comprehensive guide to
 * Flexbox: https://css-tricks.com/snippets/css/a-guide-to-flexbox/
 *
 * (!) The FlexLayout inherits all the properties of FlexItem and can utilize
 * these properties when nested inside another flex container.
 */

var FlexLayout =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FlexLayout, _React$Component);

  function FlexLayout() {
    _classCallCheck(this, FlexLayout);

    return _possibleConstructorReturn(this, _getPrototypeOf(FlexLayout).apply(this, arguments));
  }

  _createClass(FlexLayout, [{
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */
      // Extract all the flex style attributes out because we
      // don't want to pass those properties to the div dom.
      var _this$props = this.props,
          className = _this$props.className,
          display = _this$props.display,
          flexDirection = _this$props.flexDirection,
          flexWrap = _this$props.flexWrap,
          justifyContent = _this$props.justifyContent,
          alignItems = _this$props.alignItems,
          padding = _this$props.padding,
          itemSpacing = _this$props.itemSpacing,
          itemFlexBasis = _this$props.itemFlexBasis,
          props = _objectWithoutProperties(_this$props, ["className", "display", "flexDirection", "flexWrap", "justifyContent", "alignItems", "padding", "itemSpacing", "itemFlexBasis"]);
      /* eslint-enable */


      var styleProps = (0, _ReactElementUtils.getStyleProps)(styleKeys, this.props);
      return _react.default.createElement(_FlexItem.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-flex-layout"))
      }, styleProps, props), this.props.children);
    }
  }]);

  return FlexLayout;
}(_react.default.Component);

exports.default = FlexLayout;
FlexLayout.defaultProps = {
  display: 'flex',
  flexDirection: 'row',
  itemSpacing: '20px'
};
FlexLayout.propTypes = {
  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,

  /**
   * Display the layout in flex (block style) or as inline container.
   *
   * Detailed explanation:
   * https://css-tricks.com/snippets/css/a-guide-to-flexbox/#article-header-id-2
   */
  display: _propTypes.default.oneOf(['flex', 'inline-flex']),

  /**
   * Items (child nodes).
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array]),

  /**
   * Padding to wrap all children.
   */
  padding: _propTypes.default.oneOf(['0px', '5px', '10px', '15px', '20px', '30px', '40px', '0px-5px', '0px-10px', '0px-15px', '0px-20px', '5px-0px', '10px-0px', '15px-0px', '20px-0px']),

  /**
   * Set spacing between items.
   */
  itemSpacing: _propTypes.default.oneOf(['0px', '2px', '5px', '10px', '15px', '20px', '30px', '40px', '60px', '80px']),

  /**
   * Give all items flex-basis. This is useful to give equal share of space for
   * all items in the flex container.
   */
  itemFlexBasis: _propTypes.default.oneOf(['100pc']),

  /**
   * Displays items in a row or column direction.
   *
   * Detailed explanation:
   * https://css-tricks.com/snippets/css/a-guide-to-flexbox/#article-header-id-3
   */
  flexDirection: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * Align items in respect to the FlexLayout container. (stretch is default)
   *
   * Detailed explanation:
   * https://css-tricks.com/snippets/css/a-guide-to-flexbox/#article-header-id-7
   */
  alignItems: _propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),

  /**
   * Justify items in respect to the FlexLayout container. (flex-start is default)
   *
   * Detailed explanation:
   * https://css-tricks.com/snippets/css/a-guide-to-flexbox/#article-header-id-6
   */
  justifyContent: _propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Allows items to wrap inside the FlexLayout container. (nowrap is default)
   *
   * Detailed explanation:
   * https://css-tricks.com/snippets/css/a-guide-to-flexbox/#article-header-id-4
   */
  flexWrap: _propTypes.default.oneOf(['nowrap', 'wrap'])
};